module.exports = __webpack_public_path__ + "officialStatic/img/case2.77b31c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/case2.png
// module id = IRkB
// module chunks = 0